import { CheckboxItem, Row, RowItem, Text } from '@mattilsynet/mt-ui';
import Textarea from '@mattilsynet/mt-ui/dist/elements/text-area';
import React, { ChangeEvent, useCallback, useState } from 'react';
import { useKvitteringId } from '../../../common/kvittering-context';
import { useVirksomhetDeltakereInfo } from '../hooks/query-hooks';
import { useKvittering, useUpdateKvittering } from '../../kvitteringer';
import { useDebounceFn } from '../../../common/custom-hooks';
import { DEBOUNCE_MS } from '../../../constants';
export interface IIngenTilstede {
  disabled?: boolean;
}
const IngenTilstede = ({
  disabled
}: IIngenTilstede) => {
  const kvitteringId = useKvitteringId();
  const {
    data: kvittering
  } = useKvittering(kvitteringId);
  const {
    ingenTilStede,
    ingenTilStedeBegrunnelse,
    virksomhetsOrgNr
  } = useVirksomhetDeltakereInfo(kvitteringId);
  const [isIngenTilstede, setIsIngenTilStede] = useState(ingenTilStede);
  const [ingenTilstedeBegrunnelse, setIngenTilstedeBegrunnelse] = useState(ingenTilStedeBegrunnelse);
  const {
    mutate: updateKvittering
  } = useUpdateKvittering();
  const debounce = useDebounceFn(DEBOUNCE_MS);
  const onToggleIngenTilStede = useCallback(() => {
    if (kvittering) {
      updateKvittering({
        kvittering: {
          ...kvittering,
          ingenTilStede: !isIngenTilstede,
          ingenTilStedeBegrunnelse: isIngenTilstede ? ingenTilstedeBegrunnelse : ''
        }
      });
      if (isIngenTilstede) {
        setIngenTilstedeBegrunnelse('');
      }
      setIsIngenTilStede(prev => !prev);
    }
  }, [kvittering, isIngenTilstede, ingenTilstedeBegrunnelse, updateKvittering]);
  const onIngenTilStedeBegrunnelse = useCallback((event: ChangeEvent<HTMLTextAreaElement>) => {
    if (kvittering) {
      debounce(() => {
        updateKvittering({
          kvittering: {
            ...kvittering,
            ingenTilStedeBegrunnelse: event.target.value
          }
        });
      });
      setIngenTilstedeBegrunnelse(event.target.value);
    }
  }, [kvittering, debounce, updateKvittering, setIngenTilstedeBegrunnelse]);
  return <>
      <Row data-sentry-element="Row" data-sentry-source-file="ingen-tilstede.tsx">
        <CheckboxItem onClick={onToggleIngenTilStede} selected={!!isIngenTilstede} disabled={disabled} data-sentry-element="CheckboxItem" data-sentry-source-file="ingen-tilstede.tsx">
          <Text size="normal" data-sentry-element="Text" data-sentry-source-file="ingen-tilstede.tsx">
            {virksomhetsOrgNr ? 'Ingen fra virksomheten er til stede' : 'Ingen privatperson er til stede'}
          </Text>
        </CheckboxItem>
      </Row>

      {ingenTilStede && <Row style={{
      width: '97%'
    }}>
          <RowItem flex={1}>
            <Textarea onChange={onIngenTilStedeBegrunnelse} placeholder="Forklaring" value={ingenTilstedeBegrunnelse ? ingenTilstedeBegrunnelse : ''} label="Forklaring på hvorfor ingen er til stede" errorText="Forklaringen vil fremkomme i tilsynskvitteringen." />
          </RowItem>
        </Row>}
    </>;
};
export default IngenTilstede;